export default __webpack_public_path__ + "static/amazon-promo-2024--mobile-9a8fe890e95c17f26527edd303ef8313.jpg";